(() => {
  const ROOT_SELECTOR = "[data-gb-moving-features]";
  const VIEWPORT_SELECTOR = "[data-gb-moving-features-viewport]";

  const setPaused = (section, paused) => {
    const viewport = section.querySelector(VIEWPORT_SELECTOR);
    section.dataset.paused = paused ? "true" : "false";
    if (viewport && viewport.getAttribute("role") === "button") {
      viewport.setAttribute("aria-pressed", paused ? "true" : "false");
    }
  };

  const bindSection = (section) => {
    if (!section || section.dataset.gbMovingFeaturesBound === "true") {
      return;
    }

    const tapEnabled = section.dataset.tapEnabled === "true";
    if (!tapEnabled) {
      section.dataset.gbMovingFeaturesBound = "true";
      return;
    }

    const viewport = section.querySelector(VIEWPORT_SELECTOR);
    if (!viewport) {
      section.dataset.gbMovingFeaturesBound = "true";
      return;
    }

    const toggle = () => {
      const paused = section.dataset.paused === "true";
      setPaused(section, !paused);
    };

    if (window.PointerEvent) {
      viewport.addEventListener("pointerup", (event) => {
        if (event.pointerType === "touch" || event.pointerType === "pen") {
          toggle();
        }
      });
    } else {
      viewport.addEventListener("touchend", () => {
        toggle();
      });
    }

    viewport.addEventListener("keydown", (event) => {
      if (event.key === " " || event.key === "Enter") {
        event.preventDefault();
        toggle();
      }
    });

    section.dataset.gbMovingFeaturesBound = "true";
  };

  const init = (root = document) => {
    root.querySelectorAll(ROOT_SELECTOR).forEach(bindSection);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
